import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnChanges,
} from "@angular/core";
import { AsyncPipe } from "@angular/common";
import { RouterLink } from "@angular/router";
import { catchError, map, Observable, of } from "rxjs";
import { StatsService } from "@/_services/stats.service";
import {
    HazardAnalysis,
    StatsRiskFilter,
} from "@/_models/stats-risk.interface";
import { SharedComponentsModule } from "@/components/shared/shared-components.module";

interface HazardAnalysisState {
    hazards: HazardAnalysis[];
    failedToLoad: boolean;
}

@Component({
    selector: "app-hazard-analysis",
    standalone: true,
    imports: [AsyncPipe, RouterLink, SharedComponentsModule],
    templateUrl: "./hazard-analysis.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HazardAnalysisComponent implements OnChanges {
    @Input({ required: true }) filters: StatsRiskFilter;

    analysis$: Observable<HazardAnalysisState>;

    constructor(private statsService: StatsService) {}

    ngOnChanges(): void {
        this.analysis$ = this.statsService.getHazardAnalysis(this.filters).pipe(
            map((hazards) => ({ hazards, failedToLoad: false })),
            catchError(() => of({ hazards: [], failedToLoad: true })),
        );
    }
}
